import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import classNames from "classnames";

interface Props {
  title: string;
  children: React.ReactNode;
  bodyClassName?: string;
  orientation: "vertical" | "horizontal";
  correct?: boolean;
}

export default function Panel({
  title,
  children,
  bodyClassName,
  orientation,
  correct,
}: Props) {
  const textColorClassName = classNames({
    "text-white": typeof correct === "undefined",
    "text-green-500": correct === true,
    "text-red-500": correct === false,
  });
  const borderColorClassName = classNames({
    "border-white": typeof correct === "undefined",
    "border-green-500": correct === true,
    "border-red-500": correct === false,
  });
  const disabledClassName = classNames({
    "pointer-events-none": typeof correct !== "undefined",
  });
  const icon = correct ? (
    <CheckIcon className={"h-4 w-4"} />
  ) : (
    <XMarkIcon className={"h-4 w-4"} />
  );

  if (orientation === "vertical") {
    return (
      <div
        className={classNames(
          "flex flex-col rounded bg-black",
          typeof correct !== "undefined" ? "border-2" : null,
          borderColorClassName
        )}
      >
        <div
          className={classNames(
            "font-xs p-1 font-brik",
            typeof correct !== "undefined"
              ? "flex items-center"
              : "text-center",
            textColorClassName
          )}
        >
          {typeof correct !== "undefined" && (
            <span className={"mr-1"}>{icon}</span>
          )}
          {title}
        </div>
        <hr className={classNames("border-1", borderColorClassName)} />
        <div className={classNames("w-full", bodyClassName, disabledClassName)}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "flex rounded bg-black",
        typeof correct !== "undefined" ? "border-2" : null,
        borderColorClassName
      )}
    >
      <div
        style={{ writingMode: "vertical-rl" }}
        className={classNames(
          "font-xs rotate-180 p-1 py-2 font-brik",
          typeof correct !== "undefined" ? "flex items-center" : "text-center ",
          textColorClassName
        )}
      >
        {typeof correct !== "undefined" && (
          <span className={"mb-1 rotate-180"}>{icon}</span>
        )}
        {title}
      </div>

      <div className={classNames("w-[1px] border-[1px]", borderColorClassName)}>
        {" "}
      </div>

      <div className={classNames("w-full", bodyClassName, disabledClassName)}>
        {children}
      </div>
    </div>
  );
}
